import React, { Component } from 'react';
import styled from 'styled-components';
import MainPage from './MainPage';

const Container = styled.div`
  width: 100%;
  height: 100%;
  background-color: #fafafa;
  min-height: 100%;
`;

class App extends Component {
  render() {
    return (
        <Container>
         <MainPage />
        </Container>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js